module.exports = __webpack_public_path__ + "assets/img/icon3.dd3b9de9.svg";